// 封装axios
import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8';

// 请求白名单，不需要token的请求
const whiteUrl = ['Authorize/GetToken']

// 请求封装
const request = axios.create({
  // baseURL:'http://124.70.210.137:7001/api/',  // 测试环境
  baseURL:'/assets/data',  // 本地数据路径
  timeout:10000
})

// 请求拦截
request.interceptors.request.use(config=>{
  const url = config.url
  const token = sessionStorage.getItem('getToken')
  if(whiteUrl.some(vl => vl === url)){
    return config
  }else if(token){
   config.headers['token']=token
   return config
  }else{
    alert('token到期')
    this.$router.push({path:'/login'})
  }
},err=>{
  Promise.reject(err)
})

// 响应拦截
request.interceptors.response.use((response)=>{
  return response.data
},err=>{
  return err
})

export default request